//admin register
export const REGISTER_USER = 'register_user';
export const REGISTER_USER_SUCCESSFUL = 'register_user_successfull';
export const REGISTER_USER_FAILED = 'register_user_failed';

//user register
export const USER_REGISTER = 'user_register';
export const USER_REGISTER_SUCCESSFUL = 'user_register_successfull';
export const USER_REGISTER_FAILED = 'user_register_failed';
